import { toast } from "@/components/ui/sonner";

export const MAX_IMAGE_BYTES = 5 * 1024 * 1024; // 5 MB

/**
 * Validate an image file (type + size). Shows a toast and returns false if invalid.
 */
export function validateImageFile(file) {
  if (!file) return false;
  if (!file.type.startsWith("image/")) {
    toast.error("Bitte nur Bilddateien auswählen");
    return false;
  }
  if (file.size > MAX_IMAGE_BYTES) {
    toast.error("Bild darf maximal 5MB groß sein");
    return false;
  }
  return true;
}

/**
 * Read a File to a base64 data URL.
 * @returns Promise<{ dataUrl: string, base64: string, mime: string }>
 */
export function readImageAsBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const dataUrl = reader.result;
      const base64 = typeof dataUrl === "string" ? dataUrl.split(",")[1] : "";
      resolve({ dataUrl, base64, mime: file.type });
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
